import api from './api';
import { AttendanceCalcResponse, AttendanceEstado } from './horarios.service';

export interface RotativoAgente {
  _id: string;
  nombre: string;
  documento?: string;
  idAgente?: string;
  telefono?: string;
}

export interface RotativoTurno {
  _id: string;
  nombre: string;
}

export interface RotativoAsignacion {
  _id: string;
  agenteId:
    | string
    | {
        _id: string;
        nombre: string;
        documento?: string;
        idAgente?: string;
        activo?: boolean;
      };
  turnoId:
    | string
    | {
        _id: string;
        nombre: string;
        activo?: boolean;
      };
  fechaInicio: string;
  fechaFin?: string | null;
  activo: boolean;
  createdAt?: string;
}

export interface RotativosFilterPayload {
  desde: string;
  hasta: string;
  agenteId?: string;
  turnoId?: string;
  estado?: AttendanceEstado;
}

export interface RotativosAsignacionPayload {
  turnoId: string;
  fechaInicio: string;
  agenteIds: string[];
}

export const getRotativosAgentes = () => api.get<RotativoAgente[]>('/rotativos/agentes');
export const getRotativosTurnos = () => api.get<RotativoTurno[]>('/rotativos/turnos');
export const getRotativosAsignaciones = (params?: {
  agenteId?: string;
  turnoId?: string;
  desde?: string;
  hasta?: string;
}) => api.get<RotativoAsignacion[]>('/rotativos/asignaciones', { params });

export const asignarRotativo = (payload: RotativosAsignacionPayload) =>
  api.post<{ creadas: number; cerradas: number; omitidas: number }>('/rotativos/asignaciones', payload);

export const desactivarRotativoAsignacion = (id: string) => api.delete(`/rotativos/asignaciones/${id}`);

export const getReporteRotativos = (params: RotativosFilterPayload) =>
  api.get<AttendanceCalcResponse>('/reports/rotativos', { params });

export const exportReporteRotativosCsv = (params: RotativosFilterPayload) =>
  api.get('/reports/rotativos/csv', {
    params,
    responseType: 'blob',
  });
